export default {
  login: {
    succeed: "loginSucceed",
    failed: "loginFailed",
    usernameRequired: "usernameRequired",
    passwordRequired: "passwordRequired"
  },
  logout: {
    succeed: "logoutSucceed",
    failed: "logoutFailed"
  },
  request: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    processing: "requestProcessing",
    delayed: "requestDelayed"
  },
  session: {
    invalidToken: "invalidToken",
    invalidSession: "session_expired",
    inactiveAccount: "account_inactive",
    invalidSession: "sessionExpired",
  },
  getBalance: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  updatePassword: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    passwordRequired: "passwordRequired",
    newPasswordRequired: "newPasswordRequired"
  },
  addPlayer1: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    agentIdRequired: "agentIdRequired",
    accountIdRequired: "accountIdRequired",
    passwordRequired: "passwordRequired",
    tacCodeRequired: "tacCodeRequired"
  },
  getTAC1: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    agentIdRequired: "agentIdRequired",
    accountIdRequired: "accountIdRequired",
    contactPhoneRequired: "contactPhoneRequired"
  },
  addMember: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    loginIdRequired: "loginIdRequired",
    accountIdRequired: "accountIdRequired",
    passwordRequired: "passwordRequired",
    tacCodeRequired: "tacCodeRequired"
  },
  getTAC: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    referrerIdRequired: "referrerIdRequired",
    accountIdRequired: "accountIdRequired",
    contactPhoneRequired: "contactPhoneRequired"
  },
  memberTransfer: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountFromRequired: "accountFromRequired",
    accountToRequired: "accountToRequired",
    transferAmountRequired: "transferAmountRequired"
  },
  wbDeposit: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    depositAmountRequired: "depositAmountRequired",
    bankIdRequired: "bankIdRequired",
    bankAccNoRequired: "bankAccNoRequired",
    bankAccHolderRequired: "bankAccHolderRequired"
  },
  muDeposit: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    depositAmountRequired: "depositAmountRequired"
  },
  getPromo:{
    success: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getMemberRebateWallet: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getMemberRebateClaim: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    amountRequired: "amountRequired"
  },
  getMemberBankMode: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getMemberBankLookup: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getMemberBankList: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  addMemberBank: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    bankIdRequired: "bankIdRequired",
    bankAccHolderRequired: "bankAccountHolderRequired",
    bankAccNoRequired: "bankAccountNoRequired"
  },
  addMemberFavGame: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    providerCodeRequired: "providerCodeRequired",
    gameCodeRequired: "gameCodeRequired",
    gameNameRequired: "gameNameRequired",
    gameTypeRequired: "gameTypeRequired",
    imgUrlRequired: "imgUrlRequired"
  },
  deleteMemberFavGame: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    providerCodeRequired: "providerCodeRequired",
    gameCodeRequired: "gameCodeRequired"
  },
  getMemberFavGame: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  addWithdrawTicket: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    amountRequired: "amountRequired"
  },
  getStatement: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  memberTicketList: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  memberTransferList: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  dailyWinloseProvider: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    workingDateRequired: "workingDateRequired"
  },
  getMemberGameResult: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    workingDateRequired: "workingDateRequired"
  },
  launchLive22:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  launchUuslot:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getGameResult:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    resultIdRequired: "resultIdRequired"
  },
  launchPPS: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  launchPPC: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  launchYB:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  launchWB:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  launchEVO:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  launchEpic:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  launchMega:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  forgotPassword: {
    succeed: "loginSucceed",
    failed: "loginFailed",
    usernameRequired: "usernameRequired",
    contactRequired: "contactRequired"
  },
};
